import { memo } from "react";

export const Page404 = memo(() => {
  return <p>Not Found <br />
    The requested URL was not found on this server.</p>;
});